import { AllSystemProps } from 'shared/styles/props';
import { CheckboxContainer, Label, StyledCheckbox } from 'shared/ui/Checkbox/styled';
import { EmptyButton, Flex } from 'shared/ui/StyledComponents';

interface CheckboxProps extends AllSystemProps {
  onChange: (checked: boolean) => void;
  checked: boolean;
  label?: string;
  disabled?: boolean;
  labelGap?: number;
}

export const Checkbox: React.FC<CheckboxProps> = ({ checked, onChange, label, disabled, labelGap = 2, ...rest }) => (
  <CheckboxContainer {...rest}>
    <EmptyButton
      type='button'
      onClick={() => {
        onChange(!checked);
      }}
    >
      <Flex alignItems='center'>
        <StyledCheckbox disabled={disabled} checked={checked}>
          <svg viewBox='0 0 22 22' fill='none'>
            <path
              d='M18.1114 5.66675L8.3336 15.4445L3.88916 11.0001'
              strokeWidth='2'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
          </svg>
        </StyledCheckbox>
        {label && <Label ml={labelGap}>{label}</Label>}
      </Flex>
    </EmptyButton>
  </CheckboxContainer>
);
